export default "__VITE_ASSET__DofWWISS__"